export class AloBase {                
    constructor() {        
    }
}
